import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Modal from '../../common/Modal';
import Button from '../../common/Button';
import WrapperSecondary from '../../common/WrapperSecondary';
import ProjectCreate from '../../projects/create/';
import JoinProjectsToUser from '../../user/join-projects/';
import { requestDataIfNeeded as requestUserDataIfNeeded } from '../../user/duck';

class OnboardingProjectsScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  handleProjectAddSuccess = () => {
    this.props.requestUserDataIfNeeded();
    this.closeModal();
  };

  render() {
    const { t } = this.props;

    return (
      <WrapperSecondary
        title={t('onboarding.addProjects.title')}
        subtitle={t('onboarding.addProjects.subtitle')}
      >
        <h3 className="c-heading--alpha u-margin-top-huge">
          {t('onboarding.addProjects.joinProject')}
        </h3>
        <JoinProjectsToUser projectsType="DEFAULT" />

        <h3 className="c-heading--alpha u-margin-top-large">
          {t('onboarding.addProjects.addProject')}
        </h3>
        <Button styleType="outline" onClick={this.openModal}>
          {t('onboarding.addProjects.addProjectBtn')}
        </Button>

        <div className="u-text-center u-margin-top-huge">
          <Button
            onClick={() =>
              this.props.history.push('/onboarding/add-side-projects')
            }
          >
            {t('general.continue')}
          </Button>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          title={t('onboarding.addProjects.modalTitle')}
        >
          <ProjectCreate
            type="DEFAULT"
            onSuccess={this.handleProjectAddSuccess}
          />
        </Modal>
      </WrapperSecondary>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = { requestUserDataIfNeeded };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(OnboardingProjectsScreen));



// WEBPACK FOOTER //
// ./src/onboarding/add-projects/Screen.js